
  
    const countdownSpan = document.querySelector('[data-time-today]');
  

    function updateCountdownToEndOfDay() {
      const interval = setInterval(() => {
        const now = new Date();
        const endOfDay = new Date();
        endOfDay.setHours(23, 59, 59, 999); // Set to 11:59:59 PM today

        const diff = endOfDay - now;

        if (diff <= 0) {
          countdownSpan.innerHTML = "Order window closed";
          clearInterval(interval);
          return;
        }

        const hours = Math.floor(diff / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

        countdownSpan.innerHTML = `Order within <b>${hours} hrs ${minutes} mins</b>`;
      }, 1000);
    }

    updateCountdownToEndOfDay();


    document.querySelectorAll('.product-accordion').forEach(item => {
      item.addEventListener('click', () => {
     
        const isOpen = item.classList.contains('open');
    
        // Close all
        document.querySelectorAll('.product-accordion').forEach(el => el.classList.remove('open'));
    
        // Toggle clicked one if it wasn't already open
        if (!isOpen) {
          item.classList.add('open');
        }
      });
    });


  
  // function getNextWorkingDay(date, daysToAdd) {
  //   let result = new Date(date);

  //   while (daysToAdd > 0) {
  //     result.setDate(result.getDate() + 1);

  //     const day = result.getDay();

  //     if (day !== 0) {
  //       daysToAdd--;
  //     }
  //   }

  //   return result;
  // }
  // function formatDate(date){
  //   return date.toLocaleDateString("en-US", {
  //     weekday: "long",
  //     month: "long",
  //     day: "numeric"
  //   });
  // }
  // function updateDeliveryMessage(){

  //   const today = new Date();

  //   const freeDelivery = getNextWorkingDay(today, 2);

  //   let tomorrow = new Date(today);
  //   tomorrow.setDate(today.getDate() + 1);

  //   if (tomorrow.getDay() === 0){
  //     tomorrow.setDate(tomorrow.getDate() + 1);
  //   }

  //   document.getElementById("delivery-date").innerText =
  //     formatDate(freeDelivery);

  //   document.getElementById("tomorrow-date").innerText =
  //     formatDate(tomorrow);

  //   const cutoff = new Date();
  //   cutoff.setHours(cutoff.getHours() + 1);
  //   cutoff.setMinutes(cutoff.getMinutes() + 33);

  //   function updateCountdown(){
  //     const now = new Date();
  //     const diff = cutoff - now;

  //     const hrs = Math.floor(diff/(1000*60*60));
  //     const mins = Math.floor((diff%(1000*60*60))/(1000*60));

  //     document.getElementById("countdown").innerText =
  //       hrs + " hr " + mins + " mins";
  //   }

  //   updateCountdown();
  //   setInterval(updateCountdown,60000);
  // }
  // updateDeliveryMessage();


  function getNextWorkingDay(date, daysToAdd) {
  let result = new Date(date);

  while (daysToAdd > 0) {
    result.setDate(result.getDate() + 1);
    const day = result.getDay();
    if (day !== 0) {
      daysToAdd--;
    }
  }
  return result;
}

function formatDate(date) {
  return date.toLocaleDateString("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric"
  });
}

function updateDeliveryMessage() {

  const today = new Date();
  const freeDelivery = getNextWorkingDay(today, 4);

  let tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 2);

  if (tomorrow.getDay() === 0) {
    tomorrow.setDate(tomorrow.getDate() + 2);
  }

  document.getElementById("delivery-date").innerText = formatDate(freeDelivery);
  document.getElementById("tomorrow-date").innerText = formatDate(tomorrow);

  let cutoff = localStorage.getItem("cutoffTime");

  if (!cutoff) {
    let newCutoff = new Date();
    newCutoff.setHours(newCutoff.getHours() + 1);
    newCutoff.setMinutes(newCutoff.getMinutes() + 33);
    cutoff = newCutoff.getTime();
    localStorage.setItem("cutoffTime", cutoff);
  }

  function updateCountdown() {
    const now = new Date().getTime();
    let diff = cutoff - now;

    if (diff <= 0) {
      let newCutoff = new Date();
      newCutoff.setHours(newCutoff.getHours() + 1);
      newCutoff.setMinutes(newCutoff.getMinutes() + 33);
      cutoff = newCutoff.getTime();
      localStorage.setItem("cutoffTime", cutoff);
      diff = cutoff - now;
    }

    const hrs = Math.floor(diff / (1000 * 60 * 60));
    const mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

    document.getElementById("countdown").innerText =
      hrs + " hr " + mins + " mins";
  }

  updateCountdown();
  setInterval(updateCountdown, 60000);
}

updateDeliveryMessage();